var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiSliderSums = function SvgMultiSliderSums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__a",
    width: 36,
    height: 36,
    x: 46.5,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__b",
    width: 29,
    height: 29,
    x: 50.5,
    y: 4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__c",
    width: 36,
    height: 36,
    x: 65.5,
    y: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__d",
    width: 29,
    height: 29,
    x: 69.5,
    y: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__e",
    width: 36,
    height: 36,
    x: 91.5,
    y: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__f",
    width: 29,
    height: 29,
    x: 95.5,
    y: 80,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__g",
    width: 36,
    height: 36,
    x: 115.5,
    y: 114,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "multi_slider_sums_svg__h",
    width: 29,
    height: 29,
    x: 119.5,
    y: 118,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173",
    transform: "rotate(-90 33.542 -9.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 125,
    fill: "#f54f4f",
    "data-name": "Rectangle 194",
    rx: 2,
    transform: "translate(-.417)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__a)",
    transform: "rotate(90 33.54 -9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51 18a13.5 13.5 0 1 1 13.5 13.5A13.5 13.5 0 0 1 51 18",
    "data-name": "Path 326",
    opacity: 0.39
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__b)",
    transform: "rotate(90 33.54 -9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 18.5a10 10 0 1 1 10 10 10 10 0 0 1-10-10",
    "data-name": "Path 383"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 41,
    fill: "#cfcfce",
    "data-name": "Rectangle 242",
    rx: 2,
    transform: "translate(-.417 -43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    fill: "#cfcfce",
    "data-name": "Rectangle 256",
    rx: 2,
    transform: "translate(-.417 128)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173",
    transform: "rotate(-90 52.542 9.541)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 125,
    fill: "#f54f4f",
    "data-name": "Rectangle 194",
    rx: 2,
    transform: "translate(-.417)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__c)",
    transform: "rotate(90 52.54 9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70 56a13.5 13.5 0 1 1 13.5 13.5A13.5 13.5 0 0 1 70 56",
    "data-name": "Path 326",
    opacity: 0.39
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__d)",
    transform: "rotate(90 52.54 9.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M74 56.5a10 10 0 1 1 10 10 10 10 0 0 1-10-10",
    "data-name": "Path 383"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 40,
    fill: "#cfcfce",
    "data-name": "Rectangle 242",
    rx: 2,
    transform: "translate(-.417 -43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    fill: "#cfcfce",
    "data-name": "Rectangle 257",
    rx: 2,
    transform: "translate(-.417 128)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 260",
    transform: "rotate(-90 71.542 28.541)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 125,
    fill: "#f54f4f",
    "data-name": "Rectangle 194",
    rx: 2,
    transform: "translate(-.417)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__e)",
    transform: "rotate(90 71.54 28.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96 94a13.5 13.5 0 1 1 13.5 13.5A13.5 13.5 0 0 1 96 94",
    "data-name": "Path 326",
    opacity: 0.39
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__f)",
    transform: "rotate(90 71.54 28.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100 94.5a10 10 0 1 1 10 10 10 10 0 0 1-10-10",
    "data-name": "Path 383"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 40,
    fill: "#cfcfce",
    "data-name": "Rectangle 242",
    rx: 2,
    transform: "translate(-.417 -43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    fill: "#cfcfce",
    "data-name": "Rectangle 258",
    rx: 2,
    transform: "translate(-.417 128)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 261",
    transform: "rotate(-90 90.542 47.541)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 125,
    fill: "#f54f4f",
    "data-name": "Rectangle 194",
    rx: 2,
    transform: "translate(-.417)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__g)",
    transform: "rotate(90 90.54 47.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120 132a13.5 13.5 0 1 1 13.5 13.5A13.5 13.5 0 0 1 120 132",
    "data-name": "Path 326",
    opacity: 0.39
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#multi_slider_sums_svg__h)",
    transform: "rotate(90 90.54 47.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124 132.5a10 10 0 1 1 10 10 10 10 0 0 1-10-10",
    "data-name": "Path 383"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 40,
    fill: "#cfcfce",
    "data-name": "Rectangle 242",
    rx: 2,
    transform: "translate(-.417 -43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    fill: "#cfcfce",
    "data-name": "Rectangle 259",
    rx: 2,
    transform: "translate(-.417 128)"
  })))));
};
export default SvgMultiSliderSums;